import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rikmp3jx47ah">
      <MetaPixel data-id="element-1" data-mp="2mjpvpebsrcfa" />
      <Hero data-id="element-2" data-mp="31aqdi9yfoio3" />
      <StatsAndProof data-id="element-3" data-mp="31agpgrwy8ll1" />
      <PainPoints data-id="element-4" data-mp="31bs27h8dh3oa" />
      <ProductOffer data-id="element-5" data-mp="31c9w477kb5t1" />
      <Pricing showAnchor data-id="element-6" data-mp="31ctflscv2296" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wk9zooqpav17" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wiywor52xrb5" />
      <CostSection data-id="element-9" data-mp="2wip5x1c7ng4e" />
      <Pricing data-id="element-10" data-mp="2wi5nljineppu" />
      <FooterAndProofPopup data-id="element-11" data-mp="28u5yeo0zj7dd" />
    </main>;
}